import React, {useEffect, useState, useContext} from 'react'

//Node Modules
import { Link } from 'react-router-dom'

//Api
import {cdcMatch} from 'api/cdc'

//Context
import { RequestorContext } from 'context/content-context'

//Types
import { BaseCDCInfo } from 'types/cdc'

interface Props {
  language?: string,
  id?: string,
  className?: string,
  target?: string,
  tabIndex?: number,
  cdcAlias: string,
  cdcVersion: string,
  docsetAlias: string,
  docsetVersion: string,
  page: string,
  fragment?: string,
  help?: boolean,
  handleClick: (e: any)=>void,
  children: React.ReactNode
}

const PrimaryCdcLink = ({language, id, className, target, tabIndex, cdcAlias, cdcVersion, docsetAlias, docsetVersion, page, fragment, help, handleClick, children}: Props) => {
  const [href, setHref] = useState<string | undefined>()
  const requestorId = useContext(RequestorContext)

  useEffect( ()=> {
    cdcMatch(cdcAlias, cdcVersion, docsetAlias, docsetVersion).then(response => {
      let primaryCdc:BaseCDCInfo = response
      let link = `/doc/${language}/${primaryCdc.id}/${primaryCdc.version}/${docsetAlias}/${page}`
      // Check if link is to help and has requestor id
      if (help) {
        link = `${link}?help${requestorId ? '&requestorId='+requestorId : ''}`
      } else {
        link = `${link}${requestorId ? '?requestorId='+requestorId : ''}`
      }
      //check if there is a fragment
      if (fragment) {
        link = `${link}#${fragment}`
      }
      setHref(link)
    }, err => {
      setHref(undefined)
    })
  },[]) /* eslint-disable-line */




  if (href) {
    return <Link to={href} id={id} className={className} target={target} tabIndex={tabIndex} onMouseDown={handleClick}>{ children }</Link> 
  } else if (docsetAlias && docsetVersion && page){
    let standaloneLink = `/doc/${language}/${docsetAlias}/${docsetVersion}/${page}${requestorId ? '?requestorId='+requestorId : ''}`
    // Check if link is to help
    if (help) {
      standaloneLink = `${standaloneLink}?help${requestorId ? '&requestorId='+requestorId : ''}`
    }
    //check if there is a fragment
    if (fragment) {
      standaloneLink = `${standaloneLink}#${fragment}`
    }
    return <Link to={standaloneLink} id={id} className={className} target={target} tabIndex={tabIndex} onMouseDown={handleClick}>{ children }</Link> 
  } 
  else return <a href={href} id={id} className={className} target={target} tabIndex={tabIndex} onMouseDown={handleClick}>{children}</a>
}

export default PrimaryCdcLink